import React, { useState } from "react";
import { MdEdit } from "react-icons/md";
import RestaurantDetails from "./restaurants_info/RestaurantDetails";
import FoodItems from "./restaurants_info/FoodItems";
import Configuration from "./restaurants_info/Configuration";
import Review from "./restaurants_info/Review";

const RestaurantInfo = () => {
  const [current_Show, setCurrent_Show] = useState(1);

  const renderSwitch = (param) => {
    switch (param) {
      case 1:
        return <RestaurantDetails />;
      case 2:
        return <FoodItems />;
      case 3:
        return <Review />;
      case 4:
        return <Configuration />;
      default:
        return <RestaurantDetails />;
        break;
    }
  };

  return (
    <>
      <div className="coverbaner_container">
        <img src="/assets/banners/fbbanner.jpg" alt="logo" />
        <div className="cover_btn">Edit Cover Image</div>
        <div className="restarentLogo_box">
          <div className="rs_img_box">
            <img src="/assets/logo/logo.jpg" alt="logo" />
            <div className="rs_editBox">
              <MdEdit color="#fff" />
            </div>
          </div>
        </div>
      </div>

      <div className="tab_button_container">
        <div
          className={
            current_Show === 1 ? "info_tap_btn_active" : "info_tap_btn"
          }
          onClick={() => setCurrent_Show(1)}
        >
          Restaurant Details
        </div>
        <div
          className={
            current_Show === 2 ? "info_tap_btn_active" : "info_tap_btn"
          }
          onClick={() => setCurrent_Show(2)}
        >
          Food Items
        </div>
        <div
          className={
            current_Show === 3 ? "info_tap_btn_active" : "info_tap_btn"
          }
          onClick={() => setCurrent_Show(3)}
        >
          Rating & Reviews
        </div>
        <div
          className={
            current_Show === 4 ? "info_tap_btn_active" : "info_tap_btn"
          }
          onClick={() => setCurrent_Show(4)}
        >
          Configuration
        </div>
      </div>
      {renderSwitch(current_Show)}
    </>
  );
};

export default RestaurantInfo;
